import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
  Badge,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import moment from "moment";

function ComisionesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_COMISIONES = process.env.REACT_APP_URL_COMISIONES;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [fecha, setFecha] = useState(hoy);

  const [validaBoton, setValidaBoton] = useState(true);
  const [total, setTotal] = useState(0);
  
  const [porcentaje, setPorcentaje] = useState(0);

  const [inputFieldsBons, setInputFieldsBons] = useState([]);
  const [totalBon, setTotalBon] = useState(0);

  const [totalResumen, setTotalResumen] = useState(0);

  const [cambioVista, setCambioVista] = useState(0);

  // Filtro por mes
  const anioActual = moment(date).format("YYYY");
  const [selectedMes, setSelectedMes] = useState(""); // "01".."12" o ""
  const [selectedAnio, setSelectedAnio] = useState(anioActual);

useEffect(()=>{
  axios
    .get(URL_COLABORADORES, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allColaboradores = response.data;
      setColaboradores(allColaboradores);
    })
    .catch((err) => {
      console.log(err);
    });
  },[]);

  useMemo(() => {

    if (selectedColaborador) {

      axios
        .get(`${URL_ABONOS}Colaborador/${selectedColaborador}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allBon = response.data;
          let arrayTabla = allBon
            .sort((a, b) => (a.idAbono < b.idAbono ? 1 : -1))
            .map((a) => {
              const importe = parseFloat(a.importe) || 0;
              const surtido = (a.surtidos && a.surtidos[0]) || null;
              const totalGen = surtido ? parseFloat(surtido.total_general) || 0 : 0;
              const flete = surtido ? parseFloat(surtido.flete) || 0 : 0;
              const instalacion = surtido ? parseFloat(surtido.instalacion) || 0 : 0;
              const proporcion = totalGen > 0 ? importe / totalGen : 0;
              const descFleteInst = (flete + instalacion) * proporcion;
              let baseComisionable = importe - descFleteInst;
              if (
                a.formaPago === "TDC" ||
                a.formaPago === "TDD" ||
                a.formaPago === "Link de Pago"
              ) {
                baseComisionable = baseComisionable * 0.96;
              }
              if (baseComisionable < 0) baseComisionable = 0;
              return {
                _id: a._id,
                numero: surtido?.idSurtido,
                fecha: a.fecha,
                clientes: a.clientes[0].nombre_comercial,
                idClientes: a.clientes[0]._id,
                importe,
                baseComisionable,
                formaPago: a.formaPago || "",
                comision: 0,
                select: false,
              };
            })
            .filter(function (el) {
              return el != null;
            });

          let data = Object.values(arrayTabla);
          setInputFieldsBons(data);

          let activos = data.filter((e) => e.select == true);
          let TBon = activos.map((c) => parseFloat(c.baseComisionable));
          let TB = TBon.reduce((t, total, index) => t + total, 0);
          setTotalBon(TB);
        })
        .catch((err) => {
          console.log(err);
        });

    }
  }, [selectedColaborador]);

  function savePago() {
    if (porcentaje != 0) {
      Swal.fire({
        title: "Estas seguro?",
        text: "Se registrará el pago",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Enviar!",
      }).then((result) => {
        if (result.isConfirmed) {
          toggleProgreso();
          setValidaBoton(false);
          let totalMails =
            inputFieldsBons.length;

          axios
            .post(
              `${URL_COMISIONES}`,
              {
                fecha,
                importe: total,
                colaboradores: selectedColaborador,
                porcentaje,
                total:totalResumen
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((data) => {
             
              inputFieldsBons.map((a) => {
                if (a.select == true) {
                  axios
                    .patch(
                      `${URL_ABONOS}Comision/${a._id}`,
                      {
                        comisionPagada: "Si",
                        comisiones: data.data._id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      totalMails = totalMails - 1;
                      if (totalMails == 0) {
                        axios.post(
                          URL_LOGS,
                          {
                            tipo: "Pagar Comisiones",
                            detalle: `Fecha: ${fecha} Vendedor: ${selectedColaborador} `,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        );
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      }
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                      });
                      console.log(error);
                    });
                } else {
                  totalMails = totalMails - 1;
                  if (totalMails == 0) {
                    axios.post(
                      URL_LOGS,
                      {
                        tipo: "Pagar Comisiones",
                        detalle: `Fecha: ${fecha} Vendedor: ${selectedColaborador} `,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }
                }
              });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
              console.log(error);
            });
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes capturar el Porcentaje",
      });
    }
  }

  function ActualizaTotalesBons() {
    let activos = inputFieldsBons.filter((e) => e.select == true);
    let TBon = activos.map((c) => parseFloat(c.baseComisionable));
    let TB = TBon.reduce((t, total, index) => t + total, 0);
    setTotalBon(TB);

    let res = TB;
    setTotalResumen(res);
  }

  function calculaComision(e) {
    setPorcentaje(e);

    let pRes = (totalResumen * e) / 100;
    setTotal(pRes);
  }

  // Helper: ¿este abono pasa el filtro de mes/año actual?
  const pasaFiltroMes = (a) => {
    const f = String(a.fecha || "");
    const okAnio = selectedAnio ? f.slice(0, 4) === String(selectedAnio) : true;
    const okMes = selectedMes ? f.slice(5, 7) === selectedMes : true;
    return okAnio && okMes;
  };

  // Selecciona/deselecciona TODOS los abonos visibles (según filtro)
  function toggleSeleccionarTodosVisibles() {
    const visibles = inputFieldsBons.filter(pasaFiltroMes);
    if (visibles.length === 0) return;
    // Si todos los visibles ya están seleccionados, deselecciona; si no, selecciona todos.
    const todosSeleccionados = visibles.every((v) => v.select);
    const nuevoEstado = !todosSeleccionados;
    const nuevos = inputFieldsBons.map((d) => {
      if (!pasaFiltroMes(d)) return d;
      return {
        ...d,
        select: nuevoEstado,
        comision: nuevoEstado
          ? (parseFloat(d.baseComisionable) * porcentaje) / 100
          : 0,
      };
    });
    setInputFieldsBons(nuevos);

    // Recalcula totales
    const activos = nuevos.filter((e) => e.select === true);
    const TB = activos.reduce(
      (t, c) => t + (parseFloat(c.baseComisionable) || 0),
      0
    );
    setTotalBon(TB);
    setTotalResumen(TB);
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.comisionesCreate ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={8}>
                    <Button
                      size="sm"
                      href="/ListadoComisiones"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Col>
                </Row>
                <br />
                <h3 align="center">Comisiones Vendedor</h3>
                {cambioVista == 0 ? (
                  <>
                    <Row>
                      <Col md={2}>
                        <Label>Vendedor</Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={selectedColaborador}
                          onChange={(e) => {
                            setSelectedColaborador(e.target.value);
                          }}
                        >
                          <option value="0">Selecciona</option>
                          {colaboradores.map((a) => {
                            // if (a.vendedor == "Si") {
                              return (
                                <option value={a._id}>
                                  {a.nombre} {a.apellido}
                                </option>
                              );
                            // }
                          })}
                        </Input>
                      </Col>

                      <Col md={2}>
                        <Label>Mes</Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={selectedMes}
                          onChange={(e) => setSelectedMes(e.target.value)}
                        >
                          <option value="">Todos</option>
                          <option value="01">Enero</option>
                          <option value="02">Febrero</option>
                          <option value="03">Marzo</option>
                          <option value="04">Abril</option>
                          <option value="05">Mayo</option>
                          <option value="06">Junio</option>
                          <option value="07">Julio</option>
                          <option value="08">Agosto</option>
                          <option value="09">Septiembre</option>
                          <option value="10">Octubre</option>
                          <option value="11">Noviembre</option>
                          <option value="12">Diciembre</option>
                        </Input>
                      </Col>

                      <Col md={2}>
                        <Label>Año</Label>
                        <Input
                          bsSize="sm"
                          type="number"
                          min="2020"
                          step="1"
                          value={selectedAnio}
                          onChange={(e) => setSelectedAnio(e.target.value)}
                        />
                      </Col>

                      <Col md={6}>
                        <ButtonGroup id="logoutBoton">
                          {cambioVista > 0 ? (
                            <Button
                              color="info"
                              size="sm"
                              className="btn btn-success"
                              onClick={(e) => {
                                setCambioVista(cambioVista - 1);
                                let res = totalBon;
                                setTotalResumen(res);
                              }}
                            >
                              Regresar
                            </Button>
                          ) : (
                            <Button
                              color="info"
                              size="sm"
                              className="btn btn-success"
                              disabled
                            >
                              Regresar
                            </Button>
                          )}
                          {selectedColaborador ? (
                            <Button
                              color="danger"
                              size="sm"
                              className="btn btn-success"
                              onClick={(e) => {
                                setCambioVista(cambioVista + 1);
                                let res = totalBon;
                                setTotalResumen(res);
                              }}
                            >
                              Continuar
                            </Button>
                          ) : (
                            <Button
                              color="danger"
                              size="sm"
                              className="btn btn-success"
                              disabled
                            >
                              Continuar
                            </Button>
                          )}

                          {validaBoton && cambioVista == 1 ? (
                            <Button
                              color="success"
                              className="btn btn-success"
                              size="sm"
                              onClick={savePago}
                            >
                              Guardar
                            </Button>
                          ) : (
                            <Button
                              color="success"
                              type="submit"
                              className="btn btn-success"
                              size="sm"
                              disabled
                            >
                              Guardar
                            </Button>
                          )}
                        </ButtonGroup>
                      </Col>
                    </Row>
                    <br />
                   <Row className="align-items-center">
                     <Col md={6}><h4 className="mb-0">Abonos</h4></Col>
                     <Col md={6} className="text-right">
                       {inputFieldsBons.filter(pasaFiltroMes).length > 0 && (
                         <Button
                           size="sm"
                           color={
                             inputFieldsBons
                               .filter(pasaFiltroMes)
                               .every((v) => v.select)
                               ? "warning"
                               : "info"
                           }
                           onClick={toggleSeleccionarTodosVisibles}
                         >
                           {inputFieldsBons
                             .filter(pasaFiltroMes)
                             .every((v) => v.select)
                             ? "Deseleccionar todo (filtrado)"
                             : "Seleccionar todo (filtrado)"}
                         </Button>
                       )}
                     </Col>
                   </Row>
                    {inputFieldsBons.length>0?(
                    <Table striped borderless>
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Nota</th>
                        <th>Cliente</th>
                        <th>Forma Pago</th>
                        <th>Importe</th>
                        <th>Base Comisionable</th>
                        <th>Pagar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inputFieldsBons
                        .filter(pasaFiltroMes)
                        .map((a) => (
                        <tr>
                          <td>{a.fecha}</td>
                          <td>{a.numero}</td>
                          <td>{a.clientes}</td>
                          <td>{a.formaPago}</td>
                          <td>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                            }).format(a.importe)}
                          </td>
                          <td>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                            }).format(a.baseComisionable)}
                          </td>
                          <td>
                            <Input
                              type="checkbox"
                              onChange={(e) => {
                                let checked = e.target.checked;
                                if (checked == true) {
                                  setInputFieldsBons(
                                    inputFieldsBons.map((data) => {
                                      if (a._id == data._id) {
                                        data.select = checked;
                                        data.comision =
                                          (parseFloat(data.baseComisionable) *
                                            porcentaje) /
                                          100;
                                      }
                                      return data;
                                    })
                                  );
                                } else {
                                  setInputFieldsBons(
                                    inputFieldsBons.map((data) => {
                                      if (a._id == data._id) {
                                        data.select = checked;
                                        data.comision = 0;
                                      }
                                      return data;
                                    })
                                  );
                                }
                                ActualizaTotalesBons();
                              }}
                              checked={a.select}
                            />
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="negrita" align="center">
                          Total Base
                        </td>
                        <td className="negrita">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(totalBon)}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                    <br />
                  </Table>
                    
                    ):( 
                      <h4>No se encontraron Movimientos....</h4>
                      )}

                  </>
                ) :  (
                                    <>
                    <Row>
                      <Col md={2}>
                        <Label>Vendedor</Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={selectedColaborador}
                          disabled
                        >
                          <option value="0">Selecciona</option>
                          {colaboradores.map((a) => {
                            // if (a.vendedor == "Si") {
                              return (
                                <option value={a._id}>
                                  {a.nombre} {a.apellido}
                                </option>
                              );
                            // }
                          })}
                        </Input>
                      </Col>
                     

                      <Col md={10}>
                        <ButtonGroup id="logoutBoton">
                          {cambioVista > 0 ? (
                            <Button
                              color="info"
                              size="sm"
                              className="btn btn-success"
                              onClick={(e) => {
                                setCambioVista(cambioVista - 1);
                                let res = totalBon;
                                setTotalResumen(res);
                              }}
                            >
                              Regresar
                            </Button>
                          ) : (
                            <Button
                              color="info"
                              size="sm"
                              className="btn btn-success"
                              disabled
                            >
                              Regresar
                            </Button>
                          )}

                          <Button
                            color="danger"
                            size="sm"
                            className="btn btn-success"
                            disabled
                          >
                            Continuar
                          </Button>

                          {validaBoton && cambioVista == 1 ? (
                            <Button
                              color="success"
                              className="btn btn-success"
                              size="sm"
                              onClick={savePago}
                            >
                              Guardar
                            </Button>
                          ) : (
                            <Button
                              color="success"
                              type="submit"
                              className="btn btn-success"
                              size="sm"
                              disabled
                            >
                              Guardar
                            </Button>
                          )}
                        </ButtonGroup>
                      </Col>
                    </Row>
                    <br />
                    <div className="card container col-sm-5">
                      <h4 style={{ "font-weight": "bold" }}>Resumen</h4>
                      <Table>

                        <tr>
                          <th>Total</th>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                            }).format(totalResumen)}
                          </td>
                        </tr>

                        <tr>
                          <th>Porcentaje</th>
                          <td align="right">
                            <Row>
                              <Col md={9}></Col>
                              <Col md={3}>
                                <Input
                                  bsSize="sm"
                                  type="number"
                                  min="0"
                                  step="any"
                                  value={porcentaje}
                                  onChange={(e) => {
                                    calculaComision(e.target.value);
                                  }}
                                />
                              </Col>
                            </Row>
                          </td>
                        </tr>

                        <tr>
                          <th>Comision a Pagar</th>
                          <td style={{ "font-weight": "bold" }} align="right">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                            }).format(total)}
                          </td>
                        </tr>
                      </Table>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ComisionesCreate;
